import React from 'react';
import PropTypes from 'prop-types';

const ColorSwatchRgb = ({
	r = 0,
	g = 0,
	b = 0,
	style = {},
	className = ''
}) => {
	const colorForSwatch = `rgb(${r}, ${g}, ${b})`;

	return (
		<span
			style={{ backgroundColor: colorForSwatch, ...style }}
			className={`normalized-swatch mr-3 ${className}`}
		/>
	);
};

export default ColorSwatchRgb;

ColorSwatchRgb.propTypes = {
	r: PropTypes.number.isRequired,
	g: PropTypes.number.isRequired,
	b: PropTypes.number.isRequired,
	style: PropTypes.shape({}),
	className: PropTypes.string
};
